var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGatherFiller(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 53,
    viewBox: "0 0 56 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 45.4375L30.25 50.25",
    stroke: "#0F172A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28125 24.4975C11.2026 23.3861 13.4332 22.75 15.8125 22.75C23.0267 22.75 28.875 28.5983 28.875 35.8125C28.875 43.0267 23.0267 48.875 15.8125 48.875C8.59828 48.875 2.75 43.0267 2.75 35.8125C2.75 33.4332 3.38611 31.2026 4.49753 29.2812",
    stroke: "#0F172A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2477 3.72991C33.763 2.42336 35.612 2.42336 36.1273 3.72992L37.7242 7.77881C37.8815 8.17771 38.1973 8.49347 38.5962 8.65079L42.6451 10.2477C43.9516 10.763 43.9516 12.612 42.6451 13.1273L38.5962 14.7242C38.1973 14.8815 37.8815 15.1973 37.7242 15.5962L36.1273 19.6451C35.612 20.9516 33.763 20.9516 33.2477 19.6451L31.6508 15.5962C31.4935 15.1973 31.1777 14.8815 30.7788 14.7242L26.7299 13.1273C25.4234 12.612 25.4234 10.763 26.7299 10.2477L30.7788 8.65079C31.1777 8.49347 31.4935 8.17771 31.6508 7.77881L33.2477 3.72991Z",
    fill: "#2563EB",
    stroke: "#2563EB",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2712 18.4135C46.5544 17.6955 47.5706 17.6955 47.8538 18.4135L49.0922 21.5536C49.1787 21.7728 49.3522 21.9463 49.5714 22.0328L52.7115 23.2712C53.4295 23.5544 53.4295 24.5706 52.7115 24.8538L49.5714 26.0922C49.3522 26.1787 49.1787 26.3522 49.0922 26.5714L47.8538 29.7115C47.5706 30.4295 46.5544 30.4295 46.2712 29.7115L45.0328 26.5714C44.9463 26.3522 44.7728 26.1787 44.5536 26.0922L41.4135 24.8538C40.6955 24.5706 40.6955 23.5544 41.4135 23.2712L44.5536 22.0328C44.7728 21.9463 44.9463 21.7728 45.0328 21.5536L46.2712 18.4135Z",
    fill: "#2563EB",
    stroke: "#2563EB",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatherFiller);
export default __webpack_public_path__ + "static/media/gather_filler.c74c71f95c4fa0f314af5c59a1b0690a.svg";
export { ForwardRef as ReactComponent };